import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { ReportBuilderService } from '../../../../../app/modules/rope-shovel/pages/report-builder/report-builder.service';
import { LoadingService } from '../../../../../app/shared/services/loading.service';
import { WsreService } from '../../wsre.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-wsre-send-report',
  templateUrl: './wsre-send-report.component.html',
  styleUrls: ['./wsre-send-report.component.scss']
})
export class WsreSendReportComponent implements OnInit {
  emailAddress: string = "";
  validEmailString: boolean = false;
  customerName: string = "";

  reportUoM: string = "mm";
  WSREInspectionID: number = 0;
  saving: boolean = false;

  emailForm: FormGroup;
  customerNameInput: FormControl;
  emailInput: FormControl;

  styleId:number
  type:number;
  constructor(
    private dialogRef: MatDialogRef<WsreSendReportComponent>,
    private _loading: LoadingService,
    private _rbService: ReportBuilderService,private _wsreService: WsreService,
    private _notify: NotificationsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
) { }

  ngOnInit() {
    this.WSREInspectionID = this.data.WSREInspectionID;
    this.type = this.data.type;
    this.customerNameInput = new FormControl('', [
        Validators.required,
    ]);

    this.emailInput = new FormControl('', [
        Validators.required,          
    ]);
    
    this.emailForm = new FormGroup({
        customerNameInput: this.customerNameInput,
        emailInput: this.emailInput,
    });
  }

  checkEmailAddress() {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.validEmailString = re.test(String(this.emailAddress).toLowerCase());
}

onCloseClick(): void {
  this.dialogRef.close();
}

saveChanges() {
  console.log('styleid', this.styleId)
  this.saving = true;
  this._loading.startLoading();

  this._wsreService.SendReport(this.WSREInspectionID, this.emailAddress, this.customerName,this.type).subscribe(r2 => {
      this._loading.finishedLoading();
      this.saving = false;
      if (r2 != null && r2 == true) {
          this.dialogRef.close();
          this._notify.success("Successfully sent report.")
      } else {
          this._notify.warn("Failed to send report!")

      }
  });
  // if (this.validEmailString && this.emailAddress.length > 0) {
  //     this.dialogRef.close({
  //         data: this.emailAddress
  //     });
  // }
}

}
